import { render } from "./CustomerLayout.vue?vue&type=template&id=6e34da2c"
import script from "./CustomerLayout.vue?vue&type=script&lang=js"
export * from "./CustomerLayout.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/conference/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__